import Routes from "./Routes";
import "./styles/index.scss";

function App() {
  return <Routes />;
}

export default App;
